import { ErrorFilledSVG, Icon } from "@newsela/angelou";
import { TRANSLATION_DEFAULT_LANGUAGE_CODE } from "./TranslateDrawer.constants";
import {
  ILanguage,
  ITranslationError,
  ITranslationData,
} from "./TranslateDrawer.interface";
import {
  bodyStyles,
  errorAIIconStyles,
  translatedTextStyles,
} from "./TranslateDrawer.style";
import TranslateDrawerLoading from "./TranslateDrawerLoading";

interface TranslateDrawerBodyProps {
  language: ILanguage | undefined;
  isError: boolean;
  isLoading: boolean;
  translationData: ITranslationData | undefined;
  translationError: ITranslationError | undefined;
}

const TranslateDrawerBody = ({
  isError = false,
  isLoading = false,
  language,
  translationData,
  translationError,
}: TranslateDrawerBodyProps) => {
  const languageCode = language?.code || TRANSLATION_DEFAULT_LANGUAGE_CODE;

  const { translated_text: translatedText } = translationData || {};

  const { errorMessage } = translationError || {};

  if (isLoading) {
    return <TranslateDrawerLoading />;
  }

  return (
    <div css={bodyStyles}>
      <p dir="auto" lang={languageCode} css={[translatedTextStyles(isError)]}>
        {isError && (
          <Icon
            SvgComponent={ErrorFilledSVG}
            size={Icon.sizes.md}
            __cssFor={{
              root: { ...errorAIIconStyles },
            }}
          />
        )}

        {translatedText || errorMessage}
      </p>
    </div>
  );
};

export default TranslateDrawerBody;
